<template>
  <a-card :bordered="false" class="card-area">
    <div class="page-form-advanced-search">
      <a-form class="ant-advanced-search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item
              label="键">
              <a-input v-model="queryParams.keyy"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item
              label="值">
              <a-input v-model="queryParams.valuee"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item
              label="表名">
              <a-input v-model="queryParams.tableName"/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item
              label="字段">
              <a-input v-model="queryParams.fieldName" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
          </a-col>
          <a-col :span="12" :style="{ textAlign: 'right' }">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div>
      <div class="operator">
        <a-button v-hasPermission="['dict:add']" type="primary" ghost @click="add">新增</a-button>
        <a-button v-hasPermission="['dict:delete']" @click="batchDelete">删除</a-button>
        <a-button v-hasPermission="['dict:export']" @click="exportExcel">导出Excel</a-button>
      </div>
      <!-- 表格区域 -->
      <a-table bordered ref="TableInfo"
               :columns="columns"
               :rowKey="record => record.dictId"
               :dataSource="dataSource"
               :pagination="pagination"
               :loading="loading"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               @change="handleTableChange"
               :scroll="{ x: 900 }">
        <template slot="remark" slot-scope="text">
          <a-popover placement="topLeft">
            <template slot="content">
              <div style="max-width: 200px">{{text}}</div>
            </template>
            <p style="width: 200px;margin-bottom: 0">{{text}}</p>
          </a-popover>
        </template>
        <template slot="operation" slot-scope="text, record">
          <a-icon v-hasPermission="['dict:update']" type="edit" theme="twoTone" twoToneColor="#4a9ff5" @click="edit(record)" title="修改字典"></a-icon>
          <a-badge v-hasNoPermission="['dict:update']" status="warning" text="无权限"></a-badge>
        </template>
      </a-table>
    </div>
    <!-- 新增字典 -->
    <dict-add
      @close="handleDictAddClose"
      @success="handleDictAddSuccess"
     :dictAddVisiable="dictAddVisiable">
    </dict-add>
    <!-- 修改字典 -->
    <dict-edit
      ref="dictEdit"
      @close="handleDictEditClose"
      @success="handleDictEditSuccess"
      :dictEditVisiable="dictEditVisiable">
    </dict-edit>
  </a-card>
</template>

<script>
import DictAdd from './DictAdd'
import DictEdit from './DictEdit'

export default {
  name: 'Dict',
  components: {DictAdd, DictEdit},
  data () {
    return {
      advanced: false,
      dataSource: [],
      selectedRowKeys: [],
      paginationInfo: null,
      pagination: {
        pageSizeOptions: ['10', '20', '30', '40', '100'],
        defaultCurrent: 1,
        defaultPageSize: 10,
        showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => `显示 ${range[0]} ~ ${range[1]} 条记录，共 ${total} 条记录`
      },
      queryParams: {},
      dictAddVisiable: false,
      dictEditVisiable: false,
      loading: false
    }
  },
  computed: {
    columns () {
      return [{
        title: '键',
        dataIndex: 'keyy'
      }, {
        title: '值',
        dataIndex: 'valuee'
      }, {
        title: '表名',
        dataIndex: 'tableName'
      }, {
        title: '字段',
        dataIndex: 'fieldName'
      }, {
        title: '其他依据',
        dataIndex: 'otherKeyy'
      }, {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
      }]
    }
  },
  mounted () {
    this.fetch()
  },
  methods: {
    onSelectChange (selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
      if (!this.advanced) {
        this.queryParams.fieldName = ''
      }
    },
    handleDictAddSuccess () {
      this.dictAddVisiable = false
      this.$message.success('新增字典成功')
      this.search()
    },
    handleDictAddClose () {
      this.dictAddVisiable = false
    },
    add () {
      this.dictAddVisiable = true
    },
    handleDictEditSuccess () {
      this.dictEditVisiable = false
      this.$message.success('修改字典成功')
      this.search()
    },
    handleDictEditClose () {
      this.dictEditVisiable = false
    },
    edit (record) {
      this.$refs.dictEdit.setFormValues(record)
      this.dictEditVisiable = true
    },
    batchDelete () {
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请选择需要删除的记录')
        return
      }
      let that = this
      this.$confirm({
        title: '确定删除所选中的记录?',
        content: '当您点击确定按钮后，这些记录将会被彻底删除',
        centered: true,
        onOk () {
          let dictIds = that.selectedRowKeys.join(',')
          that.$delete('dict/' + dictIds).then(() => {
            that.$message.success('删除成功')
            that.selectedRowKeys = []
            that.search()
          })
        },
        onCancel () {
          that.selectedRowKeys = []
        }
      })
    },
    exportExcel () {
      this.$export('dict/excel', {
        ...this.queryParams
      })
    },
    search () {
      this.selectData({
        ...this.queryParams
      })
    },
    reset () {
      // 取消选中
      this.selectedRowKeys = []
      // 重置分页
      this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
      if (this.paginationInfo) {
        this.paginationInfo.current = this.pagination.defaultCurrent
        this.paginationInfo.pageSize = this.pagination.defaultPageSize
      }
      this.paginationInfo = null
      // 重置查询参数
      this.queryParams = {}
      this.fetch()
    },
    handleTableChange (pagination, filters, sorter) {
      this.paginationInfo = pagination
      this.fetch({
        ...this.queryParams
      })
    },
    fetch (params = {}) {
      this.loading = true
      if (this.paginationInfo) {
        // 如果分页信息不为空，则设置表格当前第几页，每页条数，并设置查询分页参数
        this.$refs.TableInfo.pagination.current = this.paginationInfo.current
        this.$refs.TableInfo.pagination.pageSize = this.paginationInfo.pageSize
        params.pageSize = this.paginationInfo.pageSize
        params.pageNum = this.paginationInfo.current
      } else {
        // 如果分页信息为空，则设置为默认值
        params.pageSize = this.pagination.defaultPageSize
        params.pageNum = this.pagination.defaultCurrent
      }
      this.$get('dict', {
        ...params
      }).then((r) => {
        let data = r.data
        const pagination = { ...this.pagination }
        pagination.total = data.total
        this.loading = false
        this.dataSource = data.rows
        this.pagination = pagination
      })
    },
    selectData (params = {}) {
      this.loading = true
      // 如果分页信息为空，则设置为默认值
      this.$refs.TableInfo.pagination.current = this.pagination.defaultCurrent
      this.$refs.TableInfo.pagination.pageSize = this.pagination.defaultPageSize
      params.pageSize = this.pagination.defaultPageSize
      params.pageNum = this.pagination.defaultCurrent
      this.$get('dict', {
        ...params
      }).then((r) => {
        let data = r.data
        const pagination = { ...this.pagination }
        pagination.total = data.total
        this.loading = false
        this.dataSource = data.rows
        this.pagination = pagination
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../utils/Common.less";
</style>
